import { ODataV4Adaptor, WebApiAdaptor, WebMethodAdaptor } from '@syncfusion/ej2-data';
import { DataManager, Query } from '@syncfusion/ej2-data';
import { HelperService } from '../services/helper.service';

export class MyDataAdaptor extends ODataV4Adaptor {

    constructor(private helper: HelperService) {
        super();
    }

    processResponse() {
        const res = super.processResponse.apply(this, arguments);

        if (res.HasError) {
            //this.helper.alert(res.ErrorMessages[0]);
            return { result: [], count: 0 };
        }
        else {
            return { result: res.Result, count: res.TotalRows };
        }
    }
}

export class ListDataAdaptor extends ODataV4Adaptor  {
    constructor(private helper: HelperService) {
        super();
    }

    processResponse(data: Object, dataManager: DataManager, query: Query) {
        //const res = super.processResponse.apply(this, arguments);

        console.log(data);

        let res: any = data;

        console.log(res);

        if (res.HasError) {
            this.helper.alert(res.ErrorMessages[0]);
            return { result: [], count: 0 };
        }
        else
            return { result: res.Result, count: res.TotalRows };

        //return { result: [], count: 0 };
    }
}

